import React, { useState } from 'react';
import { Input, Col, Row, Label } from 'reactstrap';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import Loading from '../../../components/modales/loadingModal';
import AttachCardV2 from '../../../components/cards/attachCardV2';

// APIs
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';
import { singleFileUploader } from '../../../utils/FirebaseStorage/FirebaseStorage';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalExamenes = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [loading, setLoading] = useState(false);
    const [fechaHoy, setFechaHoy] = useState(new Date(Date.now()));
    const [fechaExamenes, setFechaExamenes] = useState(new Date(Date.now()));
    const [updFile, setUpdFile] = useState([]); 

    const fileReadyToUpload = (filename) => {
        const newArr = updFile.filter(file => file.key === filename)
        return newArr.length > 0
    }

    const updateAPE = async () => {
        let body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                fechaExamenesMedicos: fechaExamenes.toISOString().split('T'),
                cmp_stat: 'LISTA_CHEQUEO'
            },

        }
        try {
            await actualizarAPE(body)
            props.updateAPE({
                estadoAPE: 'LISTA_CHEQUEO'
            })
            props.toastSuccess('APE actualizada!')
        }
        catch (error) {
            console.log(error)
            props.toastError('Hubo un error!')
        }
    }
    const handleStateUpdate = async () => {
        await updateAPE()
        props.toggle()
    }

    const fileExist = (filename) => {
        const newArr = props.fileList.filter(file => file.fileName.split('.')[0] == filename)
        return { exists: newArr.length > 0, file: newArr.length > 0 ? newArr[0] : undefined }
    }



    const renderBody = () => {
        return (
            <div>
                <div>
                    <Row style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                        <Col lg='3' md='3' xs='12'>
                            <Label for="exampleSelect">Fecha de Examenes</Label>
                            <Input
                                id="fechaExamenes"
                                name="datetime"
                                // onKeyDown={(e) => { e.preventDefault(); }}
                                value={fechaExamenes ? fechaExamenes.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                                onChange={(e) => {
                                    try {
                                        if (!isNaN(new Date(e.target.value.toUpperCase()))) setFechaExamenes(new Date(e.target.value.toUpperCase()))
                                    }
                                    catch (error) {
                                        console.log(error)
                                    }
                                }}
                                type="date"
                            />
                        </Col>
                    </Row>
                    <Row style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <Col lg='3' md='3' xs='12'>
                            <AttachCardV2
                                id={'EXAMENES'}
                                subText={`Citación exámenes médicos`}
                                attached={fileReadyToUpload('EXAMENES') || fileExist('EXAMENES').exists}
                                file={fileExist(`EXAMENES`).file}
                                apeId={props.id}
                                fileList={props.fileList}
                                setLoading={(e) => props.setLoading(e)}
                                setFileList={(e) => { props.setFileList(e) }}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    if (loading) { return <div className={'loading-area'}> <Loading /> </div> }
    else return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Aceptar'}
                onClick={() => { handleStateUpdate() }}
                buttonLoading={!(fileReadyToUpload('EXAMENES') || fileExist('EXAMENES'))}
                title={`Exámenes médicos`}
            >
                {renderBody()}
            </CustomModal>
        </React.Fragment>
    );

}

export default connect(mapStateToProps)(ModalExamenes);